import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./en.json";
import hr from "./hr.json";

const STORAGE_KEY = "language";

const savedLang = localStorage.getItem(STORAGE_KEY) || "hr";

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    hr: { translation: hr },
  },
  lng: savedLang,
  fallbackLng: "en",
  interpolation: { escapeValue: false },
});

i18n.on("languageChanged", (lng) => {
  localStorage.setItem(STORAGE_KEY, lng);
});

export default i18n;
